import { useQuery } from '@tanstack/react-query'

import type { ApiResponse } from '../../types/api'
import { api } from '../../utils/api-client'
import { queryKeys } from './keys'

interface PlatformInfo {
  download_link: string
  version: string
}

export interface DownloadLinks {
  android: PlatformInfo
  google_play_android: PlatformInfo
  ios: PlatformInfo
  adjust: {
    download_link_light?: string
    download_link_dark?: string
  }
}

const EMPTY_LINKS: DownloadLinks = {
  android: {
    download_link: '',
    version: '',
  },
  google_play_android: {
    download_link: '',
    version: '',
  },
  ios: {
    download_link: '',
    version: '',
  },
  adjust: {
    download_link_light: '',
    download_link_dark: '',
  },
}

// Several components (sidebar tabs, download banners/modals) need the same
// download links; the shared query key collapses them into one request.
const useAppDownload = (): DownloadLinks => {
  const { data } = useQuery<DownloadLinks>({
    queryKey: queryKeys.app_version,
    queryFn: async ({ signal }) => {
      const res = await api.post<ApiResponse<DownloadLinks>>(
        '/ajax_datav2.php',
        {
          type: 'get_app_version',
        },
        { signal },
      )
      return res.data.status === 1 ? res.data.info : EMPTY_LINKS
    },
  })

  return data ?? EMPTY_LINKS
}

export default useAppDownload
